import React from "react";
import { Props } from "./types";

function Icon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 18.261 14.516">
      <path
        d="M204.557,123.707a.713.713,0,0,0-.906-.085c-1.067.727-6.421,4.386-7,4.961a2.14,2.14,0,0,0,3.026,3.026c.575-.575,4.233-5.929,4.961-7A.713.713,0,0,0,204.557,123.707Zm-5.885,6.894a.713.713,0,0,1-1.009-1.009c.224-.221,1.744-1.3,3.614-2.6C199.977,128.857,198.893,130.377,198.672,130.6Z"
        transform="translate(-189.037 -120.966)"
      />
      <path
        d="M3.289,64.947l-.881.43a7.668,7.668,0,0,1-.481-6.482l1.009.484a.713.713,0,1,0,.617-1.286l-1-.478a7.714,7.714,0,0,1,5.859-3.656v1.073a.713.713,0,0,0,1.427,0V53.958A7.615,7.615,0,0,1,12.3,54.6a.713.713,0,1,0,.587-1.3A9.123,9.123,0,0,0,1.547,66.7a.713.713,0,0,0,.906.245l1.462-.713a.713.713,0,1,0-.625-1.282Z"
        transform="translate(0 -52.499)"
      />
      <path
        d="M393.541,191.914a.713.713,0,1,0-1.3.587,7.679,7.679,0,0,1-.307,6.919l-.919-.438a.713.713,0,0,0-.613,1.288l1.5.713a.713.713,0,0,0,.9-.248,9.109,9.109,0,0,0,.742-8.822Z"
        transform="translate(-376.085 -186.537)"
      />
    </svg>
  );
}

export { Icon };
